import React, { Fragment } from 'react'
import { TextField } from '@mui/material'
import { FieldRenderProps } from 'react-final-form'

const TextFieldReduxForm = ({ input, meta, disabled, title, dataCy }: FieldRenderProps<string>) => {
  const { type, value, onChange, onBlur } = input

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const currentValue = event.target.value
    if (type !== 'password') {
      const trimmedValue = currentValue.trim()
      if (trimmedValue !== value) {
        onChange(trimmedValue)
      }
    }
    onBlur(event)
  }

  return (
    <Fragment>
      <TextField
        {...input}
        disabled={disabled}
        label={title}
        placeholder={title}
        error={meta.touched && meta.invalid}
        helperText={meta.touched && meta.error}
        data-cy={dataCy}
        onBlur={handleBlur}
      />
    </Fragment>
  )
}

export default TextFieldReduxForm
